import React from 'react';
import styled from 'styled-components';
import { Badge, Tooltip, Typography, Button } from 'antd';
import { CalendarOutlined, EllipsisOutlined, MessageOutlined, LikeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

const EstateCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 12px;
  padding: 1rem;
  margin-top: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

const EstateHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const EstateHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const EstateTitle = styled(Text)`
  font-size: 1rem;
  font-weight: 500;
`;

const EstateBadges = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const StyledBadge = styled(Badge)`
  font-size: 0.75rem;
  font-weight: bold;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  color: #fff;

  &.high-priority {
    background: #d946ef;
  }
  &.low-priority {
    background: #2dd4bf;
  }
  &.time-tag {
    background: #60a5fa;
  }
  &.shared {
    background: #cbd5e1;
    color: #333;
  }
`;

const EstateListDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.5rem;
  color: #888888;
  font-size: 0.85rem;
`;

const ActionIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #888888;
`;

const OptionsButton = styled(Button)`
  border: none;
  background: transparent;
  color: #888888;
  &:hover {
    color: #333;
  }
`;
interface Badge {
    label: string;
    className?: string;  // Optional className
  }
interface EstateCardProps {
    title: string;
    dueDate: string | Date; // Or Moment object if you're using moment.js
    likes: number;
    messages: number;
    badges: Badge[];
    onClick?: () => void;
  }
  
const EstateCard: React.FC<EstateCardProps>  = ({ title, badges, dueDate, likes, messages, onClick }) => {
    const navigate = useNavigate();

  const handleCardClick = () => {
    if (onClick) {  // Check if onClick is defined
        onClick();
      }
  };
    return (
    
  <EstateCardContainer onClick={handleCardClick}>
    <EstateHeader>
      <EstateHeaderTitle>
        <EstateTitle>{title}</EstateTitle>
        <EstateBadges>
          {badges.map(({ label, className }) => (
            <StyledBadge key={label} className={className}>{label}</StyledBadge>
          ))}
        </EstateBadges>
      </EstateHeaderTitle>
      <Tooltip title="Options">
        <OptionsButton icon={<EllipsisOutlined />} />
      </Tooltip>
    </EstateHeader>
    <EstateListDetails>
      <span><CalendarOutlined /> {dueDate instanceof Date ? dueDate.toLocaleDateString() : dueDate}</span>
      <ActionIcons>
        {/* <span><LikeOutlined /> {likes}</span>
        <span><MessageOutlined /> {messages}</span> */}
      </ActionIcons>
    </EstateListDetails>
  </EstateCardContainer>
);}

export default EstateCard;